export default "__VITE_ASSET__CH1qGbPG__"